import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=3f5a1a4e&scoped=true"
import script from "./goodList.vue?vue&type=script&lang=js"
export * from "./goodList.vue?vue&type=script&lang=js"
import style0 from "./goodList.vue?vue&type=style&index=0&id=3f5a1a4e&prod&scoped=true&lang=scss"
import style1 from "./goodList.vue?vue&type=style&index=1&id=3f5a1a4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5a1a4e",
  null
  
)

export default component.exports